import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DescriptionIcon from '@material-ui/icons/Description';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { fetchConToken } from '../../helpers/fetch';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { startAlerta } from '../../actions/ui/alertas';
import { finishSpinner, startSpinner } from '../../actions/ui/spinner';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    alignItems: 'right',
  },
}));

const BotonGuardarPdf = (props) => {
  const classes = useStyles();
  const location = useLocation()
  const dispatch = useDispatch()

  const { columnsTable, totalFilas, esSeccional, idSeccional } = props
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadPdf = async () => {
    handleClose()

    try {
      dispatch(startSpinner());

      if (columnsTable.length > 0) {
        let filters = location.search !== '' ? location.search.substring(1) : location.search

        if(esSeccional && !filters.includes("seccionales"))
          filters += "&seccionales=" + idSeccional;

        let columns = []
        // eslint-disable-next-line
        columnsTable.map(c => {
          columns.push(c.id)
        })

        const response = await fetchConToken(`Indicadores/GeneratePDF?total=${totalFilas}&columns=${columns.join(",")}&${filters}`)

        if (!response.ok) {
          throw Error(response.statusText);
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/pdf") !== -1) {
          const pdfBlob = await response.blob();
          window.open(URL.createObjectURL(pdfBlob));
        }
      } else {
        dispatch(startAlerta("Debes mostrar aunque sea una columna de la tabla", "error"))
      }

      dispatch(finishSpinner());

    } catch (error) {
      console.log("Error al generar el pdf: ", error)
      dispatch(finishSpinner());
      dispatch(startAlerta("Error al generar pdf", "error"))
    }
  }

  const handleDownloadExcel = async (/*esSeccional, idSeccional*/) => {
    handleClose()

    try {
      dispatch(startSpinner());

      if (columnsTable.length > 0) {
        let filters = location.search !== '' ? location.search.substring(1) : location.search
        if(esSeccional && !filters.includes("seccionales"))
          filters += "&seccionales=" + idSeccional;
          
        let columns = []

        // eslint-disable-next-line
        columnsTable.map(c => {
          columns.push(c.id)
        })

        const response = await fetchConToken(`Indicadores/GenerateExcel?total=${totalFilas}&columns=${columns.join(",")}&${filters}`)

        if (!response.ok) {
          throw Error(response.statusText);
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("officedocument.spreadsheetml") !== -1) {
          const excelBlob = await response.blob();
          let url = window.URL.createObjectURL(excelBlob);
          let a = document.createElement('a');
          a.href = url;
          a.download = 'Reportes-Dinamicos.xlsx';
          a.click();
        }
      } else {
        dispatch(startAlerta("Debes mostrar aunque sea una columna de la tabla", "error"))
      }

      dispatch(finishSpinner());

    } catch (error) {
      console.log("Error al generar el excel: ", error)
      dispatch(finishSpinner());
      dispatch(startAlerta("Error al generar excel", "error"))
    }
  }
  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        variant="contained"
        color="primary"
        size="small"
        className={classes.button}
        startIcon={<DescriptionIcon />}
      >
        EXPORTAR
          </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleDownloadPdf}>PDF</MenuItem>
        <MenuItem onClick={handleDownloadExcel}>Excel</MenuItem>
      </Menu>
    </>
  );
}

export default BotonGuardarPdf;